module.exports = __webpack_public_path__ + "img/qrcode_frame_2.9357368f.png";